import type { Components } from "react-markdown";

import type { Citation } from "../../types/agent-chat";
import { CitationMarker } from "./CitationMarker";

/**
 * Markdown components shared by both message kinds.
 *
 * Note the deliberate absence of `rehype-raw`: the legacy chat surface renders
 * raw HTML coming out of the model, and this surface does not.
 */
const MARKDOWN_COMPONENTS = {
  code: ({ children }: { children?: React.ReactNode }) => <>{children}</>,
  pre: ({ children }: { children?: React.ReactNode }) => (
    <span className="whitespace-pre-wrap">{children}</span>
  ),
};

/**
 * Markdown components including the custom `citation` renderer.
 *
 * `Components` only enumerates HTML element names, so the custom node type the
 * remark plugin emits has to be cast in. The cast is confined to this helper.
 */
export function markdownComponents(
  citations: Record<string, Citation>,
  onOpenDocument?: (citation: Citation) => void
): Components {
  return {
    ...MARKDOWN_COMPONENTS,
    citation: ({ ids }: { ids?: string }) => (
      <CitationMarker ids={ids ?? ""} citations={citations} onOpenDocument={onOpenDocument} />
    ),
  } as Components;
}
